import * as React from "react";
import { Formik, Field, Form, ErrorMessage } from "formik";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import {
  Button,
  TextField,
  Box,
  FormHelperText,
  Typography,
} from "@mui/material";
import Paper from "@mui/material/Paper";
import useMediaQuery from "@mui/material/useMediaQuery";
import { CreateUserReferralCodeValidation } from "../../../../../validations/referralFormsValidations";
import {
  customToastify,
  checkErrorMessage,
  checkResponseData,
} from "../../../utils/utilsFunctions";
import { checkValidationCodeApi, getuserdiscountvaluesApi } from "../../../../../services/marketingApi";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
    padding: 4,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    padding: 10,
    // margin:1
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

export default function CreateNewCode(props) {
  const { createUserMarketingCode } = props;
  const detectSize600px = useMediaQuery("(min-width:600px)");
  const [marketingCode, setMarketingCode] = React.useState("");
  const [firstUserDiscount, setFirstUserDiscount] = React.useState(5);
  const [maxFirstUserDiscount, setMaxFirstUserDiscount] = React.useState(10);
  const [minFirstUserDiscount, setMinFirstUserDiscount] = React.useState(5);
  const [anotherUserDiscount, setAnotherUserDiscount] = React.useState(5);
  const [maxAnotherUserDiscount, setMaxAnotherUserDiscount] = React.useState(5);
  const [minAnotherUserDiscount, setMinAnotherUserDiscount] = React.useState(3);
  const [textCheck, setTextCheck] = React.useState("");

  const handleSetFieldValues = (props, Field, value) => {
    if (Field == "marketingCode") setMarketingCode(value);
    if (Field == "firstUserDiscount") setFirstUserDiscount(value);
    if (Field == "anotherUserDiscount") setAnotherUserDiscount(value);
    props.setFieldValue(Field, value);
  };
  const calcFirstUserDiscount = () => {
    return maxFirstUserDiscount - firstUserDiscount;
  };
  const calcAnotherUserDiscount = () => {
    return maxAnotherUserDiscount - anotherUserDiscount;
  };

  const initialValues = {
    marketingCode: "",
    firstUserDiscount,
    anotherUserDiscount,
  };

  const onSubmit = (values, props) => {
    let newValues = {
      marketingCode: values.marketingCode,
      firstUserDiscount: values.firstUserDiscount,
      anotherUserDiscount: values.anotherUserDiscount,
    };
    // console.log(newValues, "newValuesValues", values);
    createUserMarketingCode(values);
  };
  const checkCode = async (data) => {
    try {
      let response = await checkValidationCodeApi({ marketingCode });
      const resData = checkResponseData(response);
      if (resData["success"] && resData["message"]) {
        setTextCheck(resData["message"]);
      }
    } catch (error) {
      const errData = checkErrorMessage(error);
      setTextCheck(errData["titles"] || errData["message"]);
    }
  };

  const setDefaultValues = async () => {
    try {
      let response = await getuserdiscountvaluesApi({})
      const resData = checkResponseData(response);
      if (resData["success"] && resData["data"]) {
        if (resData["data"]["data"][0]) {
          setMaxFirstUserDiscount(resData["data"]["data"][0]["maxRange"])
          setMinFirstUserDiscount(resData["data"]["data"][0]["minUserFirstDiscount"])
          setMaxAnotherUserDiscount(resData["data"]["data"][0]["maxRangeAnotherDiscount"])
          setMinAnotherUserDiscount(resData["data"]["data"][0]['minUserAnotherDiscount'])
        }
      }
    } catch (error) {
      const errData = checkErrorMessage(error);
      console.log("errData", errData)
      // setTextCheck(errData["titles"] || errData["message"]);
    }
  }
  React.useEffect(() => {
    setDefaultValues()
  }, [])

  return (
    <Box sx={{ mt: 1 }}>
      <Formik
        initialValues={initialValues}
        validationSchema={CreateUserReferralCodeValidation}
        onSubmit={onSubmit}
      >
        {(props) => (
          <Form>
            <TableContainer component={Paper}>
              <Table aria-label="customized table">
                <TableHead>
                  <TableRow>
                    <StyledTableCell
                      sx={{ width: detectSize600px ? "25%" : "50%" }}
                    >
                      ساخت کد جدید
                    </StyledTableCell>
                    <StyledTableCell
                      sx={{ width: detectSize600px ? "75%" : "50%" }}
                    >
                      {" "}
                    </StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <StyledTableRow>
                    <StyledTableCell component="th" scope="row">
                      {"کد"}
                    </StyledTableCell>
                    <StyledTableCell align="left">
                      <Field
                        type="text"
                        size="small"
                        as={TextField}
                        name="marketingCode"
                        label="کد"
                        placeholder="کد"
                        value={marketingCode}
                        onChange={(e) => {
                          setTextCheck("");
                          handleSetFieldValues(
                            props,
                            "marketingCode",
                            e.target.value
                          );
                        }}
                      />
                      <FormHelperText
                        sx={{
                          m: 0,
                          p: 0,
                          color: "#f96767",
                          textAlign: "center",
                        }}
                      >
                        <ErrorMessage name="marketingCode" />
                      </FormHelperText>
                      <Typography
                        sx={{ color: (theme) => theme.palette.secondary.main }}
                      >
                        {textCheck}
                      </Typography>
                      <Button
                        variant="contained"
                        sx={{ mt: 0.1, p: 0 }}
                        color="info"
                        onClick={checkCode}
                      >
                        بررسی
                      </Button>
                      {marketingCode.length ? <>
                        <Button sx={{ m: 0, p: 0, mr: 1 }} variant="outlined" onClick={() => { navigator.clipboard.writeText(`https://umlang.com/referral/rdp/${marketingCode}`); customToastify("info", `https://umlang.com/referral/rdp/${marketingCode} کپی شد`) }}>
                          کپی لینک معرف
                        </Button>
                        <Button sx={{ m: 0, p: 0 }} variant="outlined" onClick={() => { navigator.clipboard.writeText(marketingCode); customToastify("info", `${marketingCode} کپی شد`) }}>کپی کد معرف</Button>

                      </>
                        : null}
                    </StyledTableCell>
                  </StyledTableRow>

                  <StyledTableRow>
                    <StyledTableCell component="th" scope="row">
                      {"تخفیف اولین استفاده(درصد)"}
                    </StyledTableCell>
                    <StyledTableCell align="left">
                      <Field
                        sx={{ minWidth: 200 }}
                        size="small"
                        type="number"
                        InputProps={{ inputProps: { min: minFirstUserDiscount, max: maxFirstUserDiscount } }}
                        as={TextField}
                        name="firstUserDiscount"
                        label="تخفیف(درصد)"
                        placeholder="تخفیف(درصد)"
                        value={firstUserDiscount}
                        onChange={(e) => {
                          handleSetFieldValues(
                            props,
                            "firstUserDiscount",
                            e.target.value
                          );
                        }}
                      />
                      <FormHelperText
                        sx={{
                          m: 0,
                          p: 0,
                          color: "#f96767",
                          textAlign: "center",
                        }}
                      >
                        <ErrorMessage name="firstUserDiscount" />
                      </FormHelperText>
                    </StyledTableCell>
                  </StyledTableRow>

                  <StyledTableRow>
                    <StyledTableCell component="th" scope="row">
                      {"سود شما از اولین استفاده(درصد)"}
                    </StyledTableCell>
                    <StyledTableCell align="left">{`${calcFirstUserDiscount()} درصد`}</StyledTableCell>
                  </StyledTableRow>

                  <StyledTableRow>
                    <StyledTableCell component="th" scope="row">
                      {"تخفیف استفاده های بعدی(درصد)"}
                    </StyledTableCell>
                    <StyledTableCell align="left">
                      <Field
                        sx={{ minWidth: 200 }}
                        size="small"
                        type="number"
                        InputProps={{ inputProps: { min: minAnotherUserDiscount, max: maxAnotherUserDiscount } }}
                        as={TextField}
                        name="anotherUserDiscount"
                        label="تخفیف(درصد)"
                        placeholder="تخفیف(درصد)"
                        value={anotherUserDiscount}
                        onChange={(e) => {
                          handleSetFieldValues(
                            props,
                            "anotherUserDiscount",
                            e.target.value
                          );
                        }}
                      />
                      <FormHelperText
                        sx={{
                          m: 0,
                          p: 0,
                          color: "#f96767",
                          textAlign: "center",
                        }}
                      >
                        <ErrorMessage name="word" />
                      </FormHelperText>
                    </StyledTableCell>
                  </StyledTableRow>

                  <StyledTableRow>
                    <StyledTableCell component="th" scope="row">
                      {"سود شما از استفاده بعدی(درصد)"}
                    </StyledTableCell>
                    <StyledTableCell align="left">{`${calcAnotherUserDiscount()} درصد`}</StyledTableCell>
                  </StyledTableRow>
                </TableBody>
              </Table>
            </TableContainer>
            <Button
              type="submit"
              variant="contained"
              sx={{ m: 2 }}
              color="success"
            >
              ذخیره
            </Button>
          </Form>
        )}
      </Formik>
    </Box>
  );
}
